import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import gql from 'graphql-tag'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import autobind from 'autobind-decorator'
import Button from 'orionsoft-parts/lib/components/Button'
import {withRouter} from 'react-router'
import CreateDocument from '../CreateDocument'

@withMutation(gql`
  mutation updateContractFields($preparationId: ID, $fields: JSON, $fieldType: String) {
    updateContractFields(preparationId: $preparationId, fields: $fields, fieldType: $fieldType) {
      success
    }
  }
`)
@withMessage
@withRouter
export default class Save extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    showMessage: PropTypes.func,
    getPreparation: PropTypes.object,
    updateContractFields: PropTypes.func,
    value: PropTypes.object,
    fieldType: PropTypes.string
  }

  state = {}

  @autobind
  async save() {
    this.setState({loading: true, errorMessages: null})
    try {
      await this.props.updateContractFields(
        {
          preparationId: this.props.getPreparation._id,
          fields: this.props.value,
          fieldType: this.props.fieldType
        },
        {refetchQueries: ['getPreparation']}
      )
      this.props.showMessage('Datos del documento actualizados correctamente!')
    } catch (error) {
      console.log('Error:', error)
      this.props.showMessage(error.message, {level: 'error'})
    }
    this.setState({loading: false})
  }

  render() {
    return (
      <div className={styles.container}>
        <div className="row">
          <div className="col-xs-12 col-sm-6">
            <CreateDocument preparationId={this.props.getPreparation._id} />
          </div>
          <div className="col-xs-12 col-sm-6">
            <div className={styles.buttons}>
              <Button onClick={() => this.props.router.push('/securitySatCustom')}>Inicio</Button>
              <Button
                primary
                onClick={this.save}
                disabled={!this.props.value}
                loading={this.state.loading}
              >
                Guardar
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Preparation/Save/index.js